import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p className="about-card-copy">
            I am <span className="purple">Om Jaiswal</span>, a full stack
            developer in <span className="purple">Pune, India</span>. I build
            clear web products across interface, API, and data layers,
            especially where reliability matters.
          </p>

          <p className="about-quote">
            "Trust starts with an interface that feels clear, credible, and easy to use."
          </p>
          <footer className="blockquote-footer">Om</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
